
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-ja",
      function () {
        return require("private-next-pages/privacy-ja.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy-ja"])
      });
    }
  